import React from 'react';
import PetChangeModal from 'src/pages/Dashboard/components/PetDashboardHeaderMolecules/PetChangeModal';
interface HeaderProps {
  onGeneratePDFReport: () => void;
}

export const Header = ({ onGeneratePDFReport }: HeaderProps) => {
  return (
    <>
      <PetChangeModal modal="PetDashboardVisitsChangePet" />
      {/* <SpButton onPress={onGeneratePDFReport} title="Get PDF" /> */}
    </>
  );
};
